export const ADMIN_STATUS = {}
export const CUSTOMER_STATUS = {}
export const ORDER_TYPES = {
  Express: 'Express ачаа',
  Air: 'Агаарын ачаа',
  Ground: 'Газрын ачаа',
  Container: 'Чингэлэг ачаа',
}
export const SHIPMENT_TYPES = {
  Express: 'Express',
  Air: 'Агаар',
  Ground: 'Газар',
  Container: 'Чингэлэг',
}
export const SHIPMENT_TYPES_TOENG = {
  Express: 'Express',
  Агаар: 'Air',
  Газар: 'Ground',
  Чингэлэг: 'Container',
}

export const PhoneNumberCountriesEnum = {
  USA: 'USA',
  US: 'US',
  MN: 'MN',
}

export const OrderStatusEnum = {
  New: 0,
  PartiallyReceived: 1,
  Received: 2,
  ReadyForSend: 3,
  Shipped: 4,
  ReadyForDelivery: 5,
  Delivered: 6,
}
export const OrderAdminStatus = Object.freeze({
  New: 0,
  PartiallyReceived: 1,
  Received: 2,
  ReadyForSend: 3,
  Prepared: 4,
  Shipped: 5,
  ArrivedInMongolia: 6,
  ReadyForDelivery: 7,
  Delivered: 8,
})

export const OrderStatus = Object.freeze({
  New: 'New',
  PartiallyReceived: 'PartiallyReceived',
  Received: 'Received',
  ReadyForSend: 'ReadyForSend',
  Shipped: 'Shipped',
  ReadyForDelivery: 'ReadyForDelivery',
  Delivered: 'Delivered',
})

export const ShipmentType = Object.freeze({
  Air: 'Air',
  Ground: 'Ground',
  Container: 'Container',
  Express: 'Express',
})
